import { render } from "./AboutSchoolFeature.vue?vue&type=template&id=a3b37e44&scoped=true"
import script from "./AboutSchoolFeature.vue?vue&type=script&lang=js"
export * from "./AboutSchoolFeature.vue?vue&type=script&lang=js"

import "./AboutSchoolFeature.vue?vue&type=style&index=0&id=a3b37e44&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a3b37e44"

export default script